import { BaseAPIRequestFactory, RequiredError } from './baseapi.js';
import { HttpMethod, HttpInfo } from '../http/http.js';
import { ObjectSerializer } from '../models/ObjectSerializer.js';
import { ApiException } from './exception.js';
import { isCodeInRange } from '../util.js';
async function deserializeResponseBody(response, dataType, dataFormat) {
    return ObjectSerializer.deserialize(await response.body.json(), dataType, dataFormat);
}
async function deserializeErrorBodyOrFallback(response, dataType, dataFormat) {
    try {
        return await deserializeResponseBody(response, dataType, dataFormat);
    }
    catch {
        return await response.getBodyAsAny();
    }
}
export class CreateSourceAccountApiRequestFactory extends BaseAPIRequestFactory {
    async createSourceAccount(createAccountInput, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (createAccountInput === null || createAccountInput === undefined) {
            throw new RequiredError("CreateSourceAccountApi", "createSourceAccount", "createAccountInput");
        }
        const localVarPath = '/source-accounts';
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(createAccountInput, "CreateAccountInput", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
}
export class CreateSourceAccountApiResponseProcessor {
    async createSourceAccountWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "Account", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Source account already exists", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
}
